import { render, staticRenderFns } from "./PrintWordList.vue?vue&type=template&id=279fc818&scoped=true&"
import script from "./PrintWordList.vue?vue&type=script&lang=ts&"
export * from "./PrintWordList.vue?vue&type=script&lang=ts&"
import style0 from "./PrintWordList.vue?vue&type=style&index=0&id=279fc818&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279fc818",
  null
  
)

export default component.exports